export default function moveToolsListTablet() {
  if (window.innerWidth < 1025) {
    $('#header .tools-list').appendTo('.mobile-menu-holder');
  } else {
    $('.mobile-menu-holder .tools-list').prependTo('#header .tools');
  }
}